module.exports = __webpack_public_path__ + "static/model-mitosis-a3e4870997c5b727e96f7b5d218ebafe.png";